import { Heading, Flex } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import React, { FC } from 'react'
import { system as s } from '@moonpig/launchpad-system'

const StyledHeader = styled(Heading)`
  ${s({
    fontSize: '12px',
    lineHeight: '24px',
    fontWeight: 'bold',
    color: 'colorTextLabel',
    pl: 5,
    mb: 0,
  })};
`

type Props = {
  title: string
  link?: React.ReactNode
}

export const SectionHeader: FC<Props> = ({ title, link }) => (
  <Flex justifyContent="space-between">
    <StyledHeader level="h4">{title}</StyledHeader>
    {link && link}
  </Flex>
)
